var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",class:("list list--gap-" + _vm.gapSize + " " + _vm.listStyleClass + " text-" + _vm.finalFontSize + " text-left leading-" + _vm.finalLeading)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }